import { parseISO, format } from 'date-fns';
import { cms1500JobsFields } from '../../cms1500Jobs.model';
import { useNotify } from 'react-admin';
import logger from '../../../utils/logger';
export const cms1500JobsExporter = async (jobs, notify = useNotify()) => {
  // Handle large export download
  if (jobs[0]?.url) {
    notify('Downloading CMS-1500 jobs data...', { type: 'info' });
    try {
      const response = await fetch(jobs[0].url);
      jobs = await response.json();
      notify('CMS-1500 jobs data downloaded successfully', { type: 'info' });
    } catch (error) {
      logger.error('Error downloading large export:', error);
      notify('Error downloading CMS-1500 jobs data', { type: 'error' });
      return;
    }
  }

  notify('Preparing CSV export...', { type: 'info' });

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = parseISO(dateStr);
      return isNaN(date.getTime()) ? '' : format(date, 'yyyy-MM-dd HH:mm:ss');
    } catch (e) {
      return '';
    }
  };

  const jobsForExport = jobs.map(job => {
    return {
      'ID': job[cms1500JobsFields.id],
      'Form Answer Group ID': job[cms1500JobsFields.formAnswerGroupId],
      'Patient ID': job[cms1500JobsFields.patientId],
      'Appointment ID': job[cms1500JobsFields.appointmentId],
      'Status': job[cms1500JobsFields.status],
      'Healthie CMS1500 ID': job[cms1500JobsFields.healthieCms1500Id],
      'Attempt Count': job[cms1500JobsFields.attemptCount],
      'Last Error Message': job[cms1500JobsFields.lastErrorMessage],
      'Last Attempted At': formatDate(job[cms1500JobsFields.lastAttemptedAt]),
      'Created At': formatDate(job[cms1500JobsFields.createdAt]),
      'Updated At': formatDate(job[cms1500JobsFields.updatedAt])
    };
  });

  const fields = [
    "ID",
    "Form Answer Group ID",
    "Patient ID",
    "Appointment ID",
    "Status",
    "Healthie CMS1500 ID",
    "Attempt Count",
    "Last Error Message",
    "Last Attempted At",
    "Created At",
    "Updated At"
  ];

  const csvData = fields.join(',') + '\n' +
    jobsForExport.map(job =>
      fields.map(field => {
        const value = job[field];
        return value === null || value === undefined ? '' : `"${String(value).replace(/"/g, '""')}"`;
      }).join(',')
    ).join('\n');

  const timestamp = format(new Date(), 'yyyy-MM-dd-HHmmss');
  const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = `cms1500-jobs-${timestamp}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);

  notify('CSV export completed successfully', { type: 'success' });
};
